import { Component, EventEmitter, Injector, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { GridComponent } from '@progress/kendo-angular-grid';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { CommonConstants } from 'src/app-core/constants/common-constants';
import { CommonService } from 'src/app-core/services/common.service';
import { QuotesDataModel } from 'src/app/quotes/quotes-data-model';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { CommonDataModel } from '../common-data-model';
import { InsuranceCostBreakdownComponent } from '../insurance-cost-breakdown/insurance-cost-breakdown.component';
import { CommonMethod } from 'src/app-core/methods/common-methods';

@Component({
    selector: 'app-orders-estimate-breakdown-list',
    templateUrl: './orders-estimate-breakdown-list.component.html',
    styleUrls: ['./orders-estimate-breakdown-list.component.scss']
})
export class OrdersEstimateBreakdownListComponent extends AppComponentBase implements OnInit {
    @ViewChild('grid', { static: true }) private grid: GridComponent;
    @ViewChild('insuranceBreakDown', { static: false }) public insuranceBreakDown: InsuranceCostBreakdownComponent;
    @ViewChild('estBreakDownForm', { static: true }) estBreakDownForm: NgForm;

    @Output() emitUpdateEstimate: EventEmitter<any> = new EventEmitter();

    @Input() isPanelExpended: boolean;
    @Input() orderId: string;
    @Input() readOnly: boolean;
    @Input() set accountDetailsParam(account: any) {
        if (account) {
            this.accountDetails = account;
        }
        this.onLoadItems(false);
    }
    @Input() set allFormsParams(data: any) {
        this.allForms = data;
    }
    @Input() set insuranceDetails(data: any) {
        if (data && data.isEstimateInsuranceUpdateOnChange) {
            this.markupPercentage = data.markupPercentage;
            this.isEstimateInsuranceUpdateOnChange = data.isEstimateInsuranceUpdateOnChange;
        }
        this.onLoadItems(true);
    }

    commonModel = new CommonDataModel();
    quotesModel = new QuotesDataModel();
    accountDetails: any;
    OrderTotals = this.quotesModel.OrderTotalsModel;
    isTotalLocked = false;
    estimateApply: any = null;
    editedRowIndex: number;
    allForms: any;
    initialValue: any;
    markupPercentage: any;
    isEstimateInsuranceUpdateOnChange: any;
    applyMarkupList: any = [
        { label: 'Apply Markup', id: 1 },
        { label: 'Apply Margin', id: 2 }
    ];
    insuranceData: any;
    OrderTotalsCopy: any;
    isTaxColumnVisible: boolean = false;

    constructor(
        injector: Injector,
        private toastr: ToastrService,
        private commonService: CommonService,
        private commonMethod: CommonMethod,
        private renderer: Renderer2) {
        super(injector);
    }

    ngOnInit() {
        this.commonMethod.getIsTaxColumnVisible.subscribe((data: any) => {
            this.isTaxColumnVisible = data ? true : false;
        });
    }

    onLoadItems(itemChanged: boolean) {
        if ((this.orderId || this.accountDetails)) {
            if (!this.markupPercentage) {
                this.getOrderTotals(itemChanged);
            } else if (this.markupPercentage) {
                this.calculateInsuranceRow();
            }
        }
    }

    calculateInsuranceRow() {
        this.OrderTotals.categoryBreakdown.quotesTotals.map(dataItem => {
            if (dataItem.categoryName === 'Insurance') {
                this.onMarkupPercentageChange(dataItem, this.markupPercentage);
            }
        });
    }

    calculateMarkupPercentage(dataItem: any) {
        const value = Math.abs(100 - dataItem.marginPercentage);
        const markupPercentage = Math.round(((100 / value) * 100 - 100));
        dataItem.markupPercentage = markupPercentage.toFixed(2);
    }

    calculateMarginPercentage(dataItem: any) {
        const cost = 1;
        const markupPercentage = dataItem.markupPercentage ? (+dataItem.markupPercentage) : 0;
        if (cost > 0) {
            const marginPerValue = ((cost + (cost * markupPercentage / 100) - cost) / (cost + (cost * markupPercentage / 100))) * 100;
            dataItem.marginPercentage = marginPerValue > 100 ? 100 : marginPerValue.toFixed(2);
        }
    }

    getOrderTotals(itemChanged: boolean): void {
        let queryParams = '';
        if (this.orderId) {
            queryParams = `&OrderId=${this.orderId}`;
        }
        if (this.accountDetails && this.accountDetails.accountId != null) {
            queryParams += `&AccountId=${this.accountDetails.accountId}`;
        }
        if (this.isEstimateInsuranceUpdateOnChange) {
            queryParams += `&MarkupPercentage=${this.markupPercentage}`;
        }
        if (this.accountDetails.isAccountChanged) {
            queryParams += `&IsAccountChanged=${this.accountDetails.isAccountChanged}`;
        }
        if (itemChanged) {
            queryParams += `&IsItemChanged=${itemChanged}`
        }
        if (this.accountDetails.accountId || this.orderId) {
            this.commonService.getOrderTotals(queryParams).subscribe(response => {
                if (response.data.isAccountMarkupChanged && this.orderId) {
                    this.commonService.getConfirmationPopup
                        (CommonConstants.appComponent.clientAccountmarkupMessage,
                            CommonConstants.appComponent.no, CommonConstants.appComponent.yes).then(result => {
                                if (result) {
                                    this.OrderTotals = response.data;
                                    this.OrderTotalsCopy = _.cloneDeep(response.data);
                                    if (!this.isTaxColumnVisible) {
                                        this.commonMethod.getIsTaxable.subscribe((data: boolean) => {
                                            this.OrderTotals.categoryBreakdown.quotesTotals.forEach(item => {
                                                if (item.categoryName.toLowerCase() === 'services') {
                                                    item.isTaxable = data;
                                                }
                                                if (item.isTaxable && item.categoryName.toLowerCase() === 'services') {
                                                    this.commonMethod.getIsTaxValue.subscribe((data: any) => {
                                                        this.OrderTotals.categoryBreakdown.quotesTotals.forEach(item => {
                                                            if (item.categoryName.toLowerCase() === 'services') {
                                                                item.tax = data;
                                                            }
                                                        });
                                                    });
                                                    this.commonMethod.getIsTaxTotal.subscribe((data: any) => {
                                                        this.OrderTotals.categoryBreakdown.quotesTotals.forEach(item => {
                                                            if (item.categoryName.toLowerCase() === 'services') {
                                                                item.total = data;
                                                            }
                                                        });
                                                    });
                                                }
                                            });
                                        });
                                    }
                                    if (!this.OrderTotals.categoryBreakdown.quotesTotals.find(x => !x.isLock)) {
                                        this.isTotalLocked = true;
                                    }
                                }
                            });
                } else {
                    this.OrderTotals = response.data;
                    this.OrderTotalsCopy = _.cloneDeep(response.data);
                    if (!this.isTaxColumnVisible) {
                        this.commonMethod.getIsTaxable.subscribe((data: boolean) => {
                            this.OrderTotals.categoryBreakdown.quotesTotals.forEach(item => {
                                if (item.categoryName.toLowerCase() === 'services') {
                                    item.isTaxable = data;
                                }
                                if (item.isTaxable && item.categoryName.toLowerCase() === 'services') {
                                    this.commonMethod.getIsTaxValue.subscribe((data: any) => {
                                        this.OrderTotals.categoryBreakdown.quotesTotals.forEach(item => {
                                            if (item.categoryName.toLowerCase() === 'services') {
                                                item.tax = data;
                                            }
                                        });
                                    });
                                    this.commonMethod.getIsTaxTotal.subscribe((data: any) => {
                                        this.OrderTotals.categoryBreakdown.quotesTotals.forEach(item => {
                                            if (item.categoryName.toLowerCase() === 'services') {
                                                item.total = data;
                                            }
                                        });
                                    });
                                }
                            });
                        });
                    }
                    if (!this.OrderTotals.categoryBreakdown.quotesTotals.find(x => !x.isLock)) {
                        this.isTotalLocked = true;
                    }
                }
            });
        } else {
            this.commonService.getOrderTotals('').subscribe(response => {
                this.OrderTotals = response.data;
                this.OrderTotalsCopy = _.cloneDeep(response.data);
                if (!this.OrderTotals.categoryBreakdown.quotesTotals.find(x => !x.isLock)) {
                    this.isTotalLocked = true;
                }
            });
        }
    }

    onTotalLockUnlock() {
        if (this.orderId) {
            if (!this.checkForAllFormDirty()) {
                return;
            }
        }
        this.OrderTotals.categoryBreakdown.quotesTotals.map(x => x.isLock = (!this.isTotalLocked));
        this.isTotalLocked = !this.isTotalLocked;
        this.emitUpdateEstimate.emit();
        // this.estBreakDownForm.form.markAsDirty();
    }

    onCellClickHandler(event: any, grid: any) {
        if ((event.columnIndex === 3 || event.columnIndex === 4 || event.columnIndex === 9) && !event.dataItem.isLock && event.dataItem.categoryName != 'Services') {
            this.editedRowIndex = event.rowIndex;
            const getColumnData = event.dataItem[event.column.field];
            this.initialValue = getColumnData;
            event.sender.editCell(event.rowIndex, event.columnIndex, event.dataItem);
        }
    }

    onCellCloseHandler(event: any) {
        if (event.column.field === 'markupPercentage') {
            if (event.dataItem.markupPercentage === '') {
                event.preventDefault();
            }
        }
        const getColumnData = event.dataItem[event.column.field];
        if (getColumnData) {
            if (this.initialValue !== getColumnData && !event.dataItem.isChanged) {
                event.dataItem.isChanged = true;
            }
        }
        this.initialValue = null;
    }

    onMarginPercentageChange(dataItem: any, event: any) {
        dataItem.marginPercentage = event ? (+event) : 0;
        let total = this.commonService.totalUsingCostAndMarginPercentage(parseFloat(dataItem.cost), parseFloat(dataItem.marginPercentage));
        const basPrice = total;
        let taxedAmount = (total * dataItem.taxPercentage) / 100;
        if (total > 0) {
            if (dataItem.isTaxable) {
                total = total + taxedAmount;
            } else {
                taxedAmount = 0;
            }
            dataItem.total = total.toFixed(2);
        }
        dataItem.tax = taxedAmount;
        dataItem.markupValue = basPrice - (+dataItem.cost);
        let MarkupPercentage = 0;
        if ((+dataItem.cost) > 0) {
            MarkupPercentage = this.commonService.markupPercentageUsingMarkupAndCost(parseFloat(dataItem.markupValue), parseFloat(dataItem.cost));
        }
        dataItem.markupPercentage = MarkupPercentage;
        if (total === 0) {
            this.calculateMarkupPercentage(dataItem);
        }
        this.calculateTotals();
    }

    onMarkupPercentageChange(dataItem: any, event: any) {
        dataItem.markupPercentage = event ? (+event) : 0;
        const markupPrice = this.commonService.markupValueUsingCostAndMarkupPercentage(parseFloat(dataItem.cost), parseFloat(dataItem.markupPercentage));
        let total = parseFloat(((markupPrice + (+dataItem.cost))).toFixed(2));
        let taxedAmount = parseFloat(((total * dataItem.taxPercentage) / 100).toFixed(2));
        let marginpercent = 0;
        if (total > 0) {
            marginpercent = this.commonService.marginPercentageUsingMarkupAndTotal(markupPrice, total);
            if (dataItem.isTaxable) {
                total = total + taxedAmount;
            } else {
                taxedAmount = 0;
            }
            if (!dataItem.isLock) {
                dataItem.total = total.toFixed(2);
            }
        }
        dataItem.tax = taxedAmount;
        dataItem.markupValue = markupPrice.toFixed(2);
        dataItem.marginPercentage = marginpercent > 100 ? 100 : marginpercent;
        if (total === 0) {
            this.calculateMarginPercentage(dataItem);
        }
        this.calculateTotals();
    }

    onTotalChange(dataItem: any, event: any) {
        dataItem.total = event ? (+event) : 0;
        if (dataItem.total) {
            let taxedAmount = 0;
            let actualTotal = 0;
            let markupValue = 0;
            let markupPercent = 0;
            let marginPercnet = 0;
            if (dataItem.isTaxable) {
                taxedAmount = (parseFloat(dataItem.total) * dataItem.taxPercentage) / 100;
                dataItem.subTotal = dataItem.total/(1 + (dataItem.taxPercentage/100));
                dataItem.tax = parseFloat(((dataItem.total || 0) - (dataItem.subTotal || 0)).toFixed(2));
                actualTotal = dataItem.subTotal;
                markupValue = dataItem.subTotal - dataItem.cost;
                marginPercnet = this.commonService.markupPercentageUsingMarkupAndCost(markupValue, dataItem.cost);
                markupPercent = this.commonService.marginPercentageUsingMarkupAndTotal(markupValue, actualTotal);
            } else {
                actualTotal = parseFloat(dataItem.total);
                markupValue = dataItem.total - dataItem.cost;
                dataItem.subTotal = dataItem.cost + markupValue;
                marginPercnet = this.commonService.markupPercentageUsingMarkupAndCost(markupValue, dataItem.cost);
                markupPercent = this.commonService.marginPercentageUsingMarkupAndTotal(markupValue, actualTotal);
            }
            let costValue = +dataItem.cost;
            if (costValue === 0 && markupValue === 0) {
                costValue = actualTotal;
                markupValue = actualTotal - parseFloat(dataItem.cost);
                markupPercent = this.commonService.markupPercentageUsingMarkupAndCost(markupValue, costValue);
                dataItem.markupPercentage = markupPercent;
                this.calculateMarginPercentage(dataItem);
                marginPercnet = +dataItem.marginPercentage;
            } else {
                markupValue = dataItem.subTotal - parseFloat(dataItem.cost);
                if (markupValue > 0) {
                    markupPercent = this.commonService.markupPercentageUsingMarkupAndCost(markupValue, parseFloat(dataItem.cost));
                    marginPercnet = this.commonService.marginPercentageUsingMarkupAndTotal(markupValue, actualTotal);
                }
            }
            dataItem.markupValue = markupValue;
            dataItem.marginPercentage = marginPercnet > 100 ? 100 : marginPercnet.toFixed(2);
            dataItem.markupPercentage = markupPercent.toFixed(2);
            this.calculateTotals();
        }
    }


    onTaxableChange(dataItem: any, event: any) {
        let taxedAmount = 0;
        if (event.checked) {
            taxedAmount = parseFloat(((dataItem.taxPercentage * parseFloat(dataItem.total)) / 100).toFixed(2));
            if (!dataItem.isLock) {
                dataItem.total = (taxedAmount + dataItem.total).toFixed(2);
            }
            dataItem.tax = taxedAmount;
        } else {
            if (!dataItem.isLock) {
                dataItem.total = parseFloat((parseFloat(dataItem.total) - parseFloat(dataItem.tax)).toFixed(2));
            }
            dataItem.tax = taxedAmount;
        }
        this.estBreakDownForm.form.markAsDirty();
        this.calculateTotals();
    }

    calculateTotals() {
        if (this.OrderTotals.categoryBreakdown) {
            const getTotalcost = this.OrderTotals.categoryBreakdown.quotesTotals.filter(item => item.cost).map(x => parseFloat(x.cost));
            this.OrderTotals.categoryBreakdown.overallCost = getTotalcost.length ? getTotalcost.reduce((a, b) => (+a) + (+b)).toFixed(2) : 0;
            const getoverallMarkupValue = this.OrderTotals.categoryBreakdown.quotesTotals.filter(item => item.markupValue).map(x => parseFloat(x.markupValue));
            this.OrderTotals.categoryBreakdown.overallMarkupValue = getoverallMarkupValue.length ? getoverallMarkupValue.reduce((a, b) => (+a) + (+b)).toFixed(2) : 0;
            const getoverallTax = this.OrderTotals.categoryBreakdown.quotesTotals.filter(item => item.tax).map(x => parseFloat(x.tax));
            this.OrderTotals.categoryBreakdown.overallTax = getoverallTax.length ? getoverallTax.reduce((a, b) => (+a) + (+b)).toFixed(2) : 0;
            const checkTotalIsLocked = this.OrderTotals.categoryBreakdown.quotesTotals.find(item => item.categoryName == 'Services');
            if (!checkTotalIsLocked.isLock) {
                const getoverallTotal = this.OrderTotals.categoryBreakdown.quotesTotals.filter(item => item.total).map(x => parseFloat(x.total));
                this.OrderTotals.categoryBreakdown.overallTotal = getoverallTotal.length ? getoverallTotal.reduce((a, b) => (+a) + (+b)).toFixed(2) : 0;
            }
        }
    }

    onLockUnlockEstimate(data: any) {
        if (this.orderId) {
            if (data.categoryName === 'Services' && !this.validateService()) {
                return;
            }
            if (data.categoryName === 'Insurance' && !this.validateInsurance()) {
                return;
            }
            if (data.categoryName === 'Shipping' && !this.validateShipping()) {
                return;
            }
        }
        data.isLock = !data.isLock;
        this.emitUpdateEstimate.emit();
    }

    checkForAllFormDirty(): boolean {
        if (!this.validateService()) {
            return false;
        }
        if (!this.validateInsurance()) {
            return false;
        }
        if (!this.validateShipping()) {
            return false;
        }
        return true;
    }


    validateService(): boolean {
        if (this.allForms && this.allForms.service && this.allForms.service.serviceForm.dirty) {
            this.toastr.warning('Please save pending changes');
            return false;
        }
        return true;
    }

    validateInsurance(): boolean {
        if (this.allForms && this.allForms.insurance && this.allForms.insurance.insuranceForm.dirty) {
            this.toastr.warning('Please save pending changes');
            return false;
        }
        return true;
    }

    validateShipping(): boolean {
        if (this.allForms && this.allForms.container) {
            const containerForm = this.allForms.container.containerListForm;
            let containerItemForm;
            if (this.allForms.container.containerItems.toArray().length > 0) {
                containerItemForm = this.allForms.container.containerItems.toArray().find(item => item.containerItemListForm.dirty);
            }
            if ((containerForm.dirty || containerItemForm)) {
                this.toastr.warning('Please save pending changes');
                return false;
            }
        }
        return true;
    }

    caluclateShippingEstimateBreakdownBasedOnFreightShopperCost(shippingCost: number) {
        this.OrderTotals.categoryBreakdown.quotesTotals.map(dataItem => {
            if (dataItem.categoryName === CommonConstants.totalEstimateCategoryNameConstants.shipping) {
                dataItem.cost = shippingCost;
                this.onMarkupPercentageChange(dataItem, dataItem.markupPercentage);
                dataItem.subTotal = parseFloat(dataItem.cost) + parseFloat(dataItem.markupValue);
            }
        });
    }
}
